export default __webpack_public_path__ + "static/cheer-trackers-square-1254dc9e7b57710cc1ee75ff86e6ef7f.png";